<template>
  <div
    class=" no-content">
    <i class="icon-alert-triangle"/>
    <h1>No se encontraron registros</h1>
    <div
      v-if="visible"
      class="not-found-flex">
      <h5>¿Deseas agregar alguno?</h5>
      <el-button @click="addElement">
        Agregar
      </el-button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'NotFound',
  props: {
    visible: {
      type: Boolean,
      default: true
    }
  },
  methods: {
    addElement () {
      this.$emit('addElement')
    }
  }
}
</script>

<style scoped lang="scss">
  .no-content {
    background-color: #fff;
    border-radius: 2px;
    display: flex;
    flex-direction: column;
    min-height: 50vh;
    width: 100%;
    justify-content: center;
    align-items: center;
    .not-found-flex {
      display: flex;
      flex-flow: column nowrap;
      justify-content: center;
    }
    i{
      font-size: 60px;
      color: $icon;
    }
    h1 {
      font-size: 22px;
    }
    h5{
      margin-top: 0;
    }
    .el-button{
      background-color: $primary;
      color: #ffffff;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/_shared/not-found.vue